/**
 * Export commande action
 */
export const COMMANDS_REPORT = 'COMMANDS_REPORT';
export const COMMANDS_REPORT_SUCCESS = 'COMMANDS_REPORT_SUCCESS';
export const COMMANDS_REPORT_FAILURE = 'COMMANDS_REPORT_FAILURE';

export const commandsReport = data => ({
  type: COMMANDS_REPORT,
  payload: data
});
